
import _ from 'lodash';
import { getCommunityId } from '@/utils/vc';
import {
    batchDeleteContract,       // 批量删除合同
    getContractById,           // 根据ID查询合同
    intentionToContract,       // 意向书转合同
    getContractList,           // 获取合同列表
    pageQueryContracts,        // 分页查询合同
    saveContract,              // 保存合同
    updateContract,            // 更新合同
    getContractDetail,         // 获取合同详情
    getAssetPage,              // 分页获取资产接口
    saveAsset,                 // 保存资产接口
    getAssetStatistics,        // 资产统计接口
    getAssetById,              // 根据ID获取资产接口
    getResourcePage,           // 获取资源分页列表接口
    getResourceById,           // 根据ID获取资源详情接口
    getResourceStatistics,     // 获取资源统计信息接口
    getResourceDetail,         // 获取资源详情
    updateResource,            // 更新资源接口
    deleteResource,            // 删除资源接口
    addResource,               // 新增资源接口
    billPay,                   // 账单缴费接口
    getStatistics,             // 租赁合同统计数据
    getRentalLedger,           // 分页获取租控台账列表
    deleteTransactionFlow,     // 删除交易流水
    getTransactionFlowDetail,  // 获取交易流水详情
    pageTransactionFlow,       // 分页获取交易流水列表
    saveTransactionFlow,       // 新增交易流水
    updateTransactionFlow,     // 更新交易流水
    breakContact,              // 合同解约
    initiateContractSign,     // 发起合同电子签署
    queryBuildingRoomChart,    // 查询楼栋房间信息（按单元和楼层划分）
    queryResourceWithAsset,    // 查询资源及资产信息（车位、广告、铺位）
    statisticRoomStatus,       // 统计各租赁状态的房间数量
    upload,                    // 上传文件
    getContractPartyaList,     // 获取甲方列表
    reconcile,                 // 平帐操作
    listWithAsset,             // 租控图，车位，广告位，铺位
    getrentalDetail,
} from '../../api/assets/occupancyMapApi';

const TAG = '状态管理:';
const _state = {
    communityId: getCommunityId(),
    assetList: [],        // 楼层列表数据
    resourceListZK: [],        // 楼层列表数据
    floorList: [],        // 楼层列表数据
    roomList: [],        // 楼层列表数据
    roomTotal: 0,          // 房间总数，默认0
    unitList: [],        // 单元列表数据
    buildingRoomData: [], // 存储楼栋房间信息（按单元和楼层划分）
    resourceAssetData: [], // 存储资源及资产信息
    roomStatusData: [], // 存储房间状态统计信息
    // 交易流水列表
    transactionFlowList: [],
    // 资源列表
    resourceList: [],
    contractTotal: 0,
    // 资产列表
    assets: [],
    // 租控台账统计列表总个数
    ledgerTotal: 0,
    // 租控台账列表
    ledgerList: [],
    // 资源类型
    resourceTypeList: [
        { "name": "铺位", "value": "SHOPPING_MALL" },
        { "name": "广告位", "value": "AD_SPACE" },
        { "name": "场地", "value": "VENUE" },
        { "name": "其他", "value": "OTHER" }
    ],
    type: [
        // SHOP("SHOPPING_MALL", "铺位"),
        // AD_SPACE("AD_SPACE", "广告位"),
        // VENUE("VENUE", "场地"), 停车
    ],
    // 租控状态
    currentStatusList: [
        { "name": "已出租", "value": "RENTED" },
        { "name": "空闲可租", "value": "AVAILABLE" },
        { "name": "已预定", "value": "RESERVED" },
        { "name": "装修中", "value": "RENOVATING" },
    ],
    // 缴费状态
    paymentStatusList: [
        { "name": "已逾期", "value": "OVERDUE" },
        { "name": "已支付", "value": "PAID" },
        { "name": "未支付", "value": "UNPAID" },
    ],
    // 支付方式
    rentCycleList: [
        { "name": "月付", "value": "MONTHLY" },
        { "name": "季付", "value": "QUARTERLY" },
        { "name": "半年付", "value": "HALF_YEARLY" },
        { "name": "年付", "value": "YEARLY" },
        { "name": "一次性", "value": "ONE_TIME" },
    ],
    // 合同状态
    contractStatusList: [
        { "value": "PENDING", "name": "待执行" },
        { "value": "EXECUTING", "name": "执行中" },
        { "value": "EXPIRED", "name": "已到期" },
        { "value": "TERMINATED", "name": "已终止" },
        { "value": "UNDEFINED", "name": "未定义" }
    ],

    stateList: [
        { "value": "2006", "name": "已出租" },
        { "value": "2008", "name": "空闲可租" },
        { "value": "2009", "name": "装修中" },
    ],

    //  合同模块状态
    batchDeleteResult: null,           // 批量删除结果
    currentContractDetail: null,       // 当前合同详情
    intentionConvertResult: null,      // 意向书转换结果
    contractList: [],                  // 合同列表
    contractPageData: {                // 合同分页数据
        list: [],
        total: 0,
        pageNum: 1,
        pageSize: 10
    },
    saveContractResult: null,          // 保存合同结果
    updateContractResult: null,        // 更新合同结果
    // 资产模块状态
    assetPageData: {                   // 资产分页数据
        list: [],
        total: 0,
        pageNum: 1,
        pageSize: 10
    },
    saveAssetResult: null,             // 保存资产结果
    assetStatisticsData: null,         // 资产统计数据
    currentAssetDetail: null,          // 当前资产详情

    // 资源模块状态
    resourcePageData: {                // 资源分页数据
        list: [],
        total: 0,
        pageNum: 1,
        pageSize: 10
    },
    currentResourceDetail: null,       // 当前资源详情
    resourceStatisticsData: null,      // 资源统计数据
    updateResourceResult: null,        // 更新资源结果
    deleteResourceResult: null,        // 删除资源结果
    addResourceResult: null            // 新增资源结果
}
const getters = {};
const mutations = {

    SET_COMMUNITY_ID(state, value) {
        state.communityId = value;
    },


    /**
     *
     * @param {Object} state - Vuex state对象
     * @param {Array} data - 楼层列表数组
     */
    CLEAR_ALL_RENT_LIST(state, data) {
        state.assetList = [];
        state.resourceListZK = [];
        state.floorList = [];
        state.roomList = [];
        state.unitList = [];
    },

    /**
     *
     * @param {Object} state - Vuex state对象
     * @param {Array} data - 楼层列表数组
     */
    SET_ASSETS_LIST(state, data) {
        state.assetList = data;
    },

    /**
    *
    * @param {Object} state - Vuex state对象
    * @param {Array} data - 楼层列表数组
    */
    SET_RESOURCE_LIST_ZK(state, data) {
        state.resourceListZK = data;
    },


    /**
    * 设置楼层列表数据
    * @param {Object} state - Vuex state对象
    * @param {Array} data - 楼层列表数组
    */
    SET_ROOM_LIST(state, data) {
        state.roomList = data;
    },

    /**
     * 设置楼层列表数据
     * @param {Object} state - Vuex state对象
     * @param {Array} data - 楼层列表数组
     */
    SET_FLOOR_LIST(state, data) {
        state.floorList = data;
    },

    /**
    * 设置房间总数
    * @param {Object} state - Vuex state对象
    * @param {number} total - 房间总数
    */
    SET_ROOM_TOTAL(state, value) {
        state.roomTotal = value;
    },

    /**
     * 设置单元列表数据
     * @param {Object} state - Vuex state对象
     * @param {Array} data - 单元列表数组
     */
    SET_UNIT_LIST(state, data) {
        state.unitList = data;
    },

    /**
     * 设置楼栋房间信息数据
     * @param {Object} state - Vuex state对象
     * @param {Object|Array} data - 要设置的楼栋房间数据
     */
    SET_BUILDING_ROOM_DATA(state, data) {
        state.buildingRoomData = data;
    },

    /**
     * 设置资源及资产信息数据
     * @param {Object} state - Vuex state对象
     * @param {Object|Array} data - 要设置的资源资产数据
     */
    SET_RESOURCE_ASSET_DATA(state, data) {
        state.resourceAssetData = data;
    },

    /**
     * 设置房间状态统计信息
     * @param {Object} state - Vuex state对象
     * @param {Object} data - 要设置的房间状态统计数据
     */
    SET_ROOM_STATUS_DATA(state, data) {
        state.roomStatusData = data;
    },

    /**
     * 设置交易流水列表数据
     */
    SET_TRANSACTION_FLOW_LIST(state, data) {
        state.transactionFlowList = data;
    },

    /**
    * 设置租控台账总数
    *
    * 功能：更新合同总数统计数据
    *
    * @param {Object} state Vuex状态对象
    * @param {number} value 合同总数数值
    * 时间：2026-03-24
    */
    SET_LEDGER_TOTAL(state, value) {
        state.ledgerTotal = value;
    },

    /**
     * 设置合同总数
     *
     * 功能：更新合同总数统计数据
     *
     * @param {Object} state Vuex状态对象
     * @param {number} value 合同总数数值
     * 时间：2026-03-24
     */
    SET_CONTRACT_TOTAL(state, value) {
        state.contractTotal = value;
    },

    /**
     * 设置批量删除合同结果
     *
     * 功能：更新批量删除合同操作的结果数据
     *
     * @param {Object} state Vuex状态对象
     * @param {Object} data 批量删除结果数据
     * 时间：2026-03-24
     */
    SET_BATCH_DELETE_RESULT(state, data) {
        state.batchDeleteResult = data;
    },

    /**
     * 设置当前合同详情
     *
     * 功能：更新当前查看的合同详情数据
     *
     * @param {Object} state Vuex状态对象
     * @param {Object} data 合同详情数据
     * 时间：2026-03-24
     */
    SET_CURRENT_CONTRACT_DETAIL(state, data) {
        state.currentContractDetail = data;
    },

    /**
     * 设置意向书转换结果
     *
     * 功能：更新意向书转换为合同操作的结果数据
     *
     * @param {Object} state Vuex状态对象
     * @param {Object} data 意向书转换结果数据
     * 时间：2026-03-24
     */
    SET_INTENTION_CONVERT_RESULT(state, data) {
        state.intentionConvertResult = data;
    },

    /**
     * 设置合同列表
     *
     * 功能：更新合同列表数据（非分页）
     *
     * @param {Object} state Vuex状态对象
     * @param {Array} data 合同列表数组
     * 时间：2026-03-24
     */
    SET_CONTRACT_LIST(state, data) {
        state.contractList = data;
    },

    /**
     * 设置租控台账
     *
     * 功能：更新合同列表数据（非分页）
     *
     * @param {Object} state Vuex状态对象
     * @param {Array} data 合同列表数组
     * 时间：2026-03-24
    */
    SET_LEDGER_LIST(state, data) {
        state.ledgerList = data;
    },

    /**
     * 设置合同分页数据
     *
     * 功能：更新合同分页列表数据，支持不同后端返回格式
     *
     * @param {Object} state Vuex状态对象
     * @param {Object} data 分页数据对象
     * 时间：2026-03-24
     */
    SET_CONTRACT_PAGE_DATA(state, data) {
        // 如果后端返回的是标准分页结构
        state.contractPageData = data;
    },

    /**
     * 设置保存合同结果
     *
     * 功能：更新保存合同操作的结果数据
     *
     * @param {Object} state Vuex状态对象
     * @param {Object} data 保存结果数据
     * 时间：2026-03-24
     */
    SET_SAVE_CONTRACT_RESULT(state, data) {
        state.saveContractResult = data;
    },

    /**
     * 设置更新合同结果
     *
     * 功能：更新更新合同操作的结果数据
     *
     * @param {Object} state Vuex状态对象
     * @param {Object} data 更新结果数据
     * 时间：2026-03-24
     */
    SET_UPDATE_CONTRACT_RESULT(state, data) {
        state.updateContractResult = data;
    },

    // ==================== 资产模块 Mutations ====================

    /**
     * 设置资产分页数据
     *
     * 功能：更新资产分页列表数据，支持不同后端返回格式
     *
     * @param {Object} state Vuex状态对象
     * @param {Object} data 分页数据对象
     * 时间：2026-03-24
     */
    SET_ASSET_PAGE_DATA(state, data) {
        state.assetPageData = data;
    },

    /**
     * 设置保存资产结果
     *
     * 功能：更新保存资产操作的结果数据
     *
     * @param {Object} state Vuex状态对象
     * @param {Object} data 保存结果数据
     * 时间：2026-03-24
     */
    SET_SAVE_ASSET_RESULT(state, data) {
        state.saveAssetResult = data;
    },

    /**
     * 设置资产统计数据
     *
     * 功能：更新资产统计信息数据
     *
     * @param {Object} state Vuex状态对象
     * @param {Object} data 统计数据对象
     * 时间：2026-03-24
     */
    SET_ASSET_STATISTICS_DATA(state, data) {
        state.assetStatisticsData = data;
    },

    /**
     * 设置当前资产详情
     *
     * 功能：更新当前查看的资产详情数据
     *
     * @param {Object} state Vuex状态对象
     * @param {Object} data 资产详情数据
     * 时间：2026-03-24
     */
    SET_CURRENT_ASSET_DETAIL(state, data) {
        state.currentAssetDetail = data;
    },

    // ==================== 资源模块 Mutations ====================

    /**
     * 设置资源分页数据
     *
     * 功能：更新资源分页列表数据，支持不同后端返回格式
     *
     * @param {Object} state Vuex状态对象
     * @param {Object} data 分页数据对象
     * 时间：2026-03-24
     */
    SET_RESOURCE_PAGE_DATA(state, data) {
        state.resourcePageData = data;
    },

    /**
     * 设置当前资源详情
     *
     * 功能：更新当前查看的资源详情数据
     *
     * @param {Object} state Vuex状态对象
     * @param {Object} data 资源详情数据
     * 时间：2026-03-24
     */
    SET_CURRENT_RESOURCE_DETAIL(state, data) {
        state.currentResourceDetail = data;
    },

    /**
     * 设置资源统计数据
     *
     * 功能：更新资源统计信息数据
     *
     * @param {Object} state Vuex状态对象
     * @param {Object} data 统计数据对象
     * 时间：2026-03-24
     */
    SET_RESOURCE_STATISTICS_DATA(state, data) {
        state.resourceStatisticsData = data;
    },

    /**
     * 设置更新资源结果
     *
     * 功能：更新更新资源操作的结果数据
     *
     * @param {Object} state Vuex状态对象
     * @param {Object} data 更新结果数据
     * 时间：2026-03-24
     */
    SET_UPDATE_RESOURCE_RESULT(state, data) {
        state.updateResourceResult = data;
    },

    /**
     * 设置删除资源结果
     *
     * 功能：更新删除资源操作的结果数据
     *
     * @param {Object} state Vuex状态对象
     * @param {Object} data 删除结果数据
     * 时间：2026-03-24
     */
    SET_DELETE_RESOURCE_RESULT(state, data) {
        state.deleteResourceResult = data;
    },

    /**
     * 设置新增资源结果
     *
     * 功能：更新新增资源操作的结果数据
     *
     * @param {Object} state Vuex状态对象
     * @param {Object} data 新增结果数据
     * 时间：2026-03-24
     */
    SET_ADD_RESOURCE_RESULT(state, data) {
        state.addResourceResult = data;
    },
};
const actions = {
    /**
     * 分页查询合同接口
     *
     * 功能：根据条件分页查询合同列表
     *
     * @param queryParams 查询参数对象，包含社区ID、合同名称、编号、类型、页码、页大小、支付状态等
     * @returns Promise<any> 返回分页合同列表数据
     */
    async pageQueryContractsHandler({ commit }, queryParams) {
        return new Promise((resolve, reject) => {
            pageQueryContracts(queryParams).then(res => {
                console.log(TAG, 'pageQueryContractsHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    const list = _.get(res, 'data.data.records');
                    const total = _.get(res, 'data.data.total');
                    console.log(TAG, 'pageQueryContractsHandler list=', list);
                    console.log(TAG, 'pageQueryContractsHandler total=', total);
                    commit('SET_CONTRACT_LIST', list)
                    commit('SET_CONTRACT_TOTAL', total * 1)
                    resolve(list)
                } else {
                    reject()
                }
            }).catch(error => {
                console.log(TAG, 'pageQueryContractsHandler', error);
                reject(error)
            })
        });
    },

    /**
     * 获取合同详情
     *
     * 功能：根据合同ID获取合同的详细信息
     *
     * @param id 合同ID，必须为有效的整数
     * @returns Promise<合同详情对象> 包含合同完整信息
     *
     * 时间：2026-03-24
     */
    async getContractDetailHandler({ commit }, id) {
        return new Promise((resolve, reject) => {
            getContractDetail(id).then(res => {
                console.log(TAG, 'getContractDetailHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    const detail = _.get(res, 'data.data');
                    console.log(TAG, 'getContractDetailHandler detail=', JSON.stringify(detail));
                    resolve(detail)
                } else {
                    reject()
                }

            }).catch(error => {
                console.log(TAG, 'getContractDetailHandler', error);
                reject(error)
            })
        });
    },

    /**
     * 获取资源详情
     *
     * @param id 资源id
     * @returns Promise<any> 返回更新结果
     *
     * 接口：PUT /api/resource/update
     * 时间：2026-03-26
     */
    async getResourceDetailHandler({ commit }, id) {
        return new Promise((resolve, reject) => {
            getResourceDetail(id).then(res => {
                console.log(TAG, 'getResourceDetailHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    const detail = _.get(res, 'data.data');
                    console.log(TAG, 'getResourceDetailHandler detail=', JSON.stringify(detail));
                    resolve(detail)
                } else {
                    reject()
                }

            }).catch(error => {
                console.log(TAG, 'getResourceDetailHandler', error);
                reject(error)
            })
        });
    },

    /**
     * 新增合同
     * @param obj 新增的对象
     * @returns Promise<any> 返回分页合同列表数据
     */
    async saveContractHandler({ commit }, obj) {
        return new Promise((resolve, reject) => {
            saveContract(obj).then(res => {
                console.log(TAG, 'saveContractHandler res', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    resolve(res);
                } else {
                    reject(res.data)
                }
            }).catch(error => {
                console.log(TAG, 'saveContractHandler', error);
                reject(error)
            })
        });
    },

    // ==================== 合同模块 ====================

    /**
     * 批量删除合同
     * 返回值存储变量：batchDeleteResult
     */
    async batchDeleteContractHandler({ commit }, params) {
        return new Promise((resolve, reject) => {
            batchDeleteContract(params).then(res => {
                console.log(TAG, 'batchDeleteContractHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    commit('SET_BATCH_DELETE_RESULT', res.data);
                    resolve(res);
                } else {
                    reject();
                }
            }).catch(error => {
                console.log(TAG, 'batchDeleteContractHandler', error);
                reject(error);
            });
        });
    },

    /**
     * 根据ID查询合同
     * 返回值存储变量：currentContractDetail
     */
    async getContractByIdHandler({ commit }, id) {
        return new Promise((resolve, reject) => {
            getContractById(id).then(res => {
                console.log(TAG, 'getContractByIdHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    commit('SET_CURRENT_CONTRACT_DETAIL', res.data);
                    resolve(res);
                } else {
                    reject();
                }
            }).catch(error => {
                console.log(TAG, 'getContractByIdHandler', error);
                reject(error);
            });
        });
    },

    /**
     * 意向书转合同
     * 返回值存储变量：intentionConvertResult
     */
    async intentionToContractHandler({ commit }, params) {
        return new Promise((resolve, reject) => {
            intentionToContract(params).then(res => {
                console.log(TAG, 'intentionToContractHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    commit('SET_INTENTION_CONVERT_RESULT', res.data);
                    resolve(res);
                } else {
                    reject();
                }
            }).catch(error => {
                console.log(TAG, 'intentionToContractHandler', error);
                reject(error);
            });
        });
    },

    /**
     * 获取合同列表
     * 返回值存储变量：contractList
     */
    async getContractListHandler({ commit }, params) {
        return new Promise((resolve, reject) => {
            getContractList(params).then(res => {
                console.log(TAG, 'getContractListHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    commit('SET_CONTRACT_LIST', res.data);
                    resolve(res);
                } else {
                    reject();
                }
            }).catch(error => {
                console.log(TAG, 'getContractListHandler', error);
                reject(error);
            });
        });
    },

    /**
     * 更新合同
     * 返回值存储变量：updateContractResult
     */
    async updateContractHandler({ commit }, params) {
        return new Promise((resolve, reject) => {
            updateContract(params).then(res => {
                console.log(TAG, 'updateContractHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    commit('SET_UPDATE_CONTRACT_RESULT', res.data);
                    resolve(res);
                } else {
                    reject();
                }
            }).catch(error => {
                console.log(TAG, 'updateContractHandler', error);
                reject(error);
            });
        });
    },

    // ==================== 资产模块 ====================

    /**
     * 分页获取资产
     * 返回值存储变量：assetPageData
     */
    async getAssetPageHandler({ commit }, params) {
        return new Promise((resolve, reject) => {
            getAssetPage(params).then(res => {
                console.log(TAG, 'getAssetPageHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    commit('SET_ASSET_PAGE_DATA', res.data);
                    resolve(res);
                } else {
                    reject();
                }
            }).catch(error => {
                console.log(TAG, 'getAssetPageHandler', error);
                reject(error);
            });
        });
    },

    /**
     * 保存资产
     * 返回值存储变量：saveAssetResult
     */
    async saveAssetHandler({ commit }, params) {
        return new Promise((resolve, reject) => {
            saveAsset(params).then(res => {
                console.log(TAG, 'saveAssetHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    commit('SET_SAVE_ASSET_RESULT', res.data);
                    resolve(res);
                } else {
                    reject();
                }
            }).catch(error => {
                console.log(TAG, 'saveAssetHandler', error);
                reject(error);
            });
        });
    },

    /**
     * 资产统计
     * 返回值存储变量：assetStatisticsData
     */
    async getAssetStatisticsHandler({ commit }, params) {
        return new Promise((resolve, reject) => {
            getAssetStatistics(params).then(res => {
                console.log(TAG, 'getAssetStatisticsHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    commit('SET_ASSET_STATISTICS_DATA', res.data);
                    resolve(res);
                } else {
                    reject();
                }
            }).catch(error => {
                console.log(TAG, 'getAssetStatisticsHandler', error);
                reject(error);
            });
        });
    },

    /**
     * 根据ID获取资产
     * 返回值存储变量：currentAssetDetail
     */
    async getAssetByIdHandler({ commit }, id) {
        return new Promise((resolve, reject) => {
            getAssetById(id).then(res => {
                console.log(TAG, 'getAssetByIdHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    commit('SET_CURRENT_ASSET_DETAIL', res.data);
                    resolve(res);
                } else {
                    reject();
                }
            }).catch(error => {
                console.log(TAG, 'getAssetByIdHandler', error);
                reject(error);
            });
        });
    },

    // ==================== 资源模块 ====================

    /**
     * 获取资源分页列表
     * 返回值存储变量：resourcePageData
     */
    async getResourcePageHandler({ commit }, params) {
        return new Promise((resolve, reject) => {
            getResourcePage(params).then(res => {
                console.log(TAG, 'getResourcePageHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    // done
                    const list = _.get(res, 'data.data.records');
                    console.log(TAG, 'getResourcePageHandler list=', list);
                    commit('SET_RESOURCE_PAGE_DATA', list);
                    resolve(list);
                } else {
                    reject();
                }
            }).catch(error => {
                console.log(TAG, 'getResourcePageHandler', error);
                reject(error);
            });
        });
    },

    /**
     * 根据ID获取资源详情
     * 返回值存储变量：currentResourceDetail
     */
    async getResourceByIdHandler({ commit }, id) {
        return new Promise((resolve, reject) => {
            getResourceById(id).then(res => {
                console.log(TAG, 'getResourceByIdHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    commit('SET_CURRENT_RESOURCE_DETAIL', res.data);
                    resolve(res);
                } else {
                    reject();
                }
            }).catch(error => {
                console.log(TAG, 'getResourceByIdHandler', error);
                reject(error);
            });
        });
    },

    /**
     * 获取资源统计信息
     * 返回值存储变量：resourceStatisticsData
     */
    async getResourceStatisticsHandler({ commit }, params) {
        return new Promise((resolve, reject) => {
            getResourceStatistics(params).then(res => {
                console.log(TAG, 'getResourceStatisticsHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    commit('SET_RESOURCE_STATISTICS_DATA', res.data);
                    resolve(res);
                } else {
                    reject();
                }
            }).catch(error => {
                console.log(TAG, 'getResourceStatisticsHandler', error);
                reject(error);
            });
        });
    },

    /**
     * 更新资源
     * 返回值存储变量：updateResourceResult
     */
    async updateResourceHandler({ commit }, params) {
        return new Promise((resolve, reject) => {
            updateResource(params).then(res => {
                console.log(TAG, 'updateResourceHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    commit('SET_UPDATE_RESOURCE_RESULT', res.data);
                    resolve(res);
                } else {
                    reject();
                }
            }).catch(error => {
                console.log(TAG, 'updateResourceHandler', error);
                reject(error);
            });
        });
    },

    /**
     * 删除资源
     * 返回值存储变量：deleteResourceResult
     */
    async deleteResourceHandler({ commit }, id) {
        return new Promise((resolve, reject) => {
            deleteResource(id).then(res => {
                console.log(TAG, 'deleteResourceHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    commit('SET_DELETE_RESOURCE_RESULT', res.data);
                    resolve(res);
                } else {
                    reject();
                }
            }).catch(error => {
                console.log(TAG, 'deleteResourceHandler', error);
                reject(error);
            });
        });
    },

    /**
     * 新增资源
     * 返回值存储变量：addResourceResult
     */
    async addResourceHandler({ commit }, params) {
        return new Promise((resolve, reject) => {
            addResource(params).then(res => {
                console.log(TAG, 'addResourceHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    commit('SET_ADD_RESOURCE_RESULT', res.data);
                    resolve(res);
                } else {
                    reject();
                }
            }).catch(error => {
                console.log(TAG, 'addResourceHandler', error);
                reject(error);
            });
        });
    },

    /**
     * 账单缴费
     * 返回值存储变量：billPayResult
     */
    async billPayHandler({ commit }, params) {
        return new Promise((resolve, reject) => {
            billPay(params).then(res => {
                console.log('billPayHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    // commit('SET_BILL_PAY_RESULT', res.data);
                    resolve(res);
                } else {
                    reject(res);
                }
            }).catch(error => {
                console.log('billPayHandler error', error);
                reject(error);
            });
        });
    },

    async getStatisticsHandler({ commit }, params) {
        return new Promise((resolve, reject) => {
            getStatistics(params).then(res => {
                console.log('getStatisticsHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    const obj = _.get(res, 'data.data')
                    resolve(obj);
                } else {
                    reject(res);
                }
            }).catch(error => {
                console.log('getStatisticsHandler error', error);
                reject(error);
            });
        });
    },

    // 获取租控台账列表
    async getRentalLedgerHandler({ commit }, params) {
        return new Promise((resolve, reject) => {
            getRentalLedger(params).then(res => {
                console.log('getRentalLedgerHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    const list = _.get(res, 'data.data.records');
                    const total = _.get(res, 'data.data.total');
                    commit('SET_LEDGER_LIST', list)
                    commit('SET_LEDGER_TOTAL', total * 1)
                    resolve(list);
                } else {
                    reject(res);
                }
            }).catch(error => {
                console.log('getRentalLedgerHandler error', error);
                reject(error);
            });
        });
    },

    //---------------------交易流水部分------------------------------------

    /**
     * 删除交易流水
     * 返回值存储变量：deleteTransactionFlowResult
     */
    async deleteTransactionFlowHandler({ commit }, params) {
        return new Promise((resolve, reject) => {
            deleteTransactionFlow(params).then(res => {
                console.log(TAG, 'deleteTransactionFlowHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    commit('SET_DELETE_TRANSACTION_FLOW_RESULT', res.data);
                    resolve(res);
                } else {
                    reject();
                }
            }).catch(error => {
                console.log(TAG, 'deleteTransactionFlowHandler', error);
                reject(error);
            });
        });
    },

    /**
     * 获取交易流水详情
     * 返回值存储变量：transactionFlowDetail
     */
    async getTransactionFlowDetailHandler({ commit }, params) {
        return new Promise((resolve, reject) => {
            getTransactionFlowDetail(params).then(res => {
                console.log(TAG, 'getTransactionFlowDetailHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    const detail = _.get(res, 'data.data')
                    commit('SET_TRANSACTION_FLOW_DETAIL', detail);
                    resolve(detail);
                } else {
                    reject();
                }
            }).catch(error => {
                console.log(TAG, 'getTransactionFlowDetailHandler', error);
                reject(error);
            });
        });
    },

    /**
     * 分页获取交易流水列表
     * 返回值存储变量：transactionFlowList
     */
    async pageTransactionFlowHandler({ commit }, params) {
        return new Promise((resolve, reject) => {
            pageTransactionFlow(params).then(res => {
                console.log(TAG, 'pageTransactionFlowHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    const list = _.get(res, 'data.data.records')
                    const total = _.get(res, 'data.data.total')
                    commit('SET_TRANSACTION_FLOW_LIST', list);
                    resolve(total * 1);
                } else {
                    reject();
                }
            }).catch(error => {
                console.log(TAG, 'pageTransactionFlowHandler', error);
                reject(error);
            });
        });
    },

    /**
     * 新增交易流水
     * 返回值存储变量：saveTransactionFlowResult
     */
    async saveTransactionFlowHandler({ commit }, params) {
        return new Promise((resolve, reject) => {
            saveTransactionFlow(params).then(res => {
                console.log(TAG, 'saveTransactionFlowHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    commit('SET_SAVE_TRANSACTION_FLOW_RESULT', res.data);
                    resolve(res);
                } else {
                    reject();
                }
            }).catch(error => {
                console.log(TAG, 'saveTransactionFlowHandler', error);
                reject(error);
            });
        });
    },

    /**
     * 更新交易流水
     * 返回值存储变量：updateTransactionFlowResult
     */
    async updateTransactionFlowHandler({ commit }, params) {
        return new Promise((resolve, reject) => {
            updateTransactionFlow(params).then(res => {
                console.log(TAG, 'updateTransactionFlowHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    commit('SET_UPDATE_TRANSACTION_FLOW_RESULT', res.data);
                    resolve(res);
                } else {
                    reject();
                }
            }).catch(error => {
                console.log(TAG, 'updateTransactionFlowHandler', error);
                reject(error);
            });
        });
    },

    /**
     * 合同解约
     */
    async breakContactHandler({ commit }, params) {
        return new Promise((resolve, reject) => {
            breakContact(params).then(res => {
                console.log(TAG, 'breakContactHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    resolve(res);
                } else {
                    reject();
                }
            }).catch(error => {
                console.log(TAG, 'breakContactHandler', error);
                reject(error);
            });
        });
    },

    /**
     * 发起合同电子签署（对接 e签宝）
     * @param {Object} params - { contractId: number }
     * @returns Promise<{ signFlowId, signStatus, resultUrl }>
     */
    async initiateContractSignHandler({ commit }, params) {
        return new Promise((resolve, reject) => {
            initiateContractSign(params).then(res => {
                console.log(TAG, 'initiateContractSignHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    const signData = _.get(res, 'data.data') || {};
                    resolve(signData);
                } else {
                    reject(_.get(res, 'data'));
                }
            }).catch(error => {
                console.log(TAG, 'initiateContractSignHandler', error);
                reject(error);
            });
        });
    },

    /**
     * 查询楼栋房间信息（按单元和楼层划分）
     */
    async queryBuildingRoomChartHandler({ commit }, params = {}) {
        return new Promise((resolve, reject) => {
            queryBuildingRoomChart(params).then(res => {
                console.log(TAG, 'queryBuildingRoomChartHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    const floorList = _.get(res, 'data.data.floorList');
                    const roomTotal = _.get(res, 'data.data.roomTotal');
                    const unitList = _.get(res, 'data.data.unitList');

                    const newUnitList = [];
                    _.each(unitList, unit => {
                        unit.expand = true
                        newUnitList.push(unit);
                    })

                    const roomList = [];
                    _.each(unitList, unit => {
                        const layerList = _.get(unit, 'layerList');
                        _.each(layerList, layer => {
                            const tempList = _.get(layer, 'roomList') || []
                            roomList.push(...tempList);
                        })

                    })
                    commit('SET_FLOOR_LIST', floorList);
                    commit('SET_ROOM_TOTAL', roomTotal);
                    commit('SET_ROOM_LIST', roomList);
                    commit('SET_UNIT_LIST', newUnitList);

                    resolve(roomList);
                } else {
                    reject();
                }
            }).catch(error => {
                console.log(TAG, 'queryBuildingRoomChartHandler', error);
                reject(error);
            });
        });
    },

    /**
     * 查询资源及资产信息（车位、广告、铺位）
     */
    async queryResourceWithAssetHandler({ commit }, params = {}) {
        return new Promise((resolve, reject) => {
            queryResourceWithAsset(params).then(res => {
                console.log(TAG, 'queryResourceWithAssetHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    resolve(res);
                } else {
                    reject();
                }
            }).catch(error => {
                console.log(TAG, 'queryResourceWithAssetHandler', error);
                reject(error);
            });
        });
    },
    /**
     * 统计各租赁状态的房间数量
     */
    async statisticRoomStatusHandler({ commit }, params = {}) {
        return new Promise((resolve, reject) => {
            statisticRoomStatus(params).then(res => {
                console.log(TAG, 'statisticRoomStatusHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    const detail = _.get(res, 'data.data');
                    resolve(detail);
                } else {
                    reject();
                }
            }).catch(error => {
                console.log(TAG, 'statisticRoomStatusHandler', error);
                reject(error);
            });
        });
    },

    /**
    * 统计各租赁状态的房间数量
    */
    async uploadFile({ commit }, params = {}) {
        return new Promise((resolve, reject) => {
            upload(params).then(res => {
                console.log(TAG, 'uploadFile res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    const url = _.get(res, 'data.data');
                    resolve(url);
                } else {
                    reject();
                }
            }).catch(error => {
                console.log(TAG, 'uploadFile', error);
                reject(error);
            });
        });
    },

    /**
     * 获取甲方列表
     */
    async getContractPartyaListHandler({ commit }) {
        return new Promise((resolve, reject) => {
            getContractPartyaList().then(res => {
                console.log(TAG, 'getContractPartyaListHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    const data = _.get(res, 'data.data');
                    resolve(data);
                } else {
                    reject();
                }
            }).catch(error => {
                console.log(TAG, 'getContractPartyaListHandler', error);
                reject(error);
            });
        });
    },

    /**
     * 平帐操作
     */
    async reconcileHandler({ commit }, params) {
        return new Promise((resolve, reject) => {
            reconcile(params).then(res => {
                console.log(TAG, 'reconcileHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    const data = _.get(res, 'data.data');
                    resolve(data);
                } else {
                    reject();
                }
            }).catch(error => {
                console.log(TAG, 'reconcileHandler', error);
                reject(error);
            });
        });
    },

    /**
     * 租控图，车位，广告位，铺位
     */
    async listWithAssetHandler({ commit }, params) {
        return new Promise((resolve, reject) => {
            listWithAsset(params).then(res => {
                console.log(TAG, 'listWithAssetHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    const assetList = _.get(res, 'data.data.assetList')
                    const resourceList = _.get(res, 'data.data.resourceList')
                    commit('SET_ASSETS_LIST', assetList);
                    commit('SET_RESOURCE_LIST_ZK', resourceList);
                    resolve(res);
                } else {
                    reject();
                }
            }).catch(error => {
                console.log(TAG, 'listWithAssetHandler', error);
                reject(error);
            });
        });
    },


    /**
     * 获取租控台账详情
     */
    async getrentalDetailHandler({ commit }, params) {
        return new Promise((resolve, reject) => {
            getrentalDetail(params).then(res => {
                console.log(TAG, 'getrentalDetailHandler res=', res);
                const code = _.get(res, 'data.code');
                if (code == 0) {
                    const detail = _.get(res, 'data.data')
                    resolve(detail);
                } else {
                    reject();
                }
            }).catch(error => {
                console.log(TAG, 'getrentalDetailHandler', error);
                reject(error);
            });
        });
    },

};

const assetModule = {
    namespaced: true,
    state: () => _state,
    getters,
    mutations,
    actions,
}

export default assetModule